module.exports = __webpack_public_path__ + "img/StorageAdd.53373b38.svg";